/* src/app/shared/components/modals/report-modal/report-modal.component.scss */
ion-content {
  max-height: calc(100% - 56px) !important;
  height: 744px !important;
}
ion-radio {
  --color-checked: var(--ion-color-success);
  --color:var(--ion-color-success);
}
.questionPopoverIcon {
  color: var(--ion-color-secondary-contrast);
  zoom: 1.8;
  margin-top: 7px;
  border-radius: 50%;
}
.questionPopoverIcon:hover {
  transform: scale(1.2);
  background-color: rgba(255, 255, 255, 0.062745098);
}
.custom-popover-css {
  --width: fit-content !important;
  --max-width: 400px !important;
  color: var(--ion-color-secondary-contrast);
}
.inputfile {
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 999;
  cursor: pointer;
}
ion-img::part(image) {
  max-height: 200px;
}
.action-buttons-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 8px 8px;
}
@media only screen and (max-width: 720px) {
  ion-header,
  ion-content {
    zoom: 0.8;
  }
  .action-buttons-container {
    zoom: 0.8;
  }
}
/*# sourceMappingURL=report-modal.component-V5IVJZHD.css.map */
